// covered-by: frontends/carrie/src/ask-v2/home/__tests__/homeCopy.test.ts
/**
 * Pure helpers behind the personalized home copy: the client clock christo
 * receives, and the split that keeps the brand accent on the word "Puntt".
 */

function pad2(value: number): string {
  return value < 10 ? `0${value}` : String(value);
}

/** Wall-clock time in the browser's zone, `YYYY-MM-DDTHH:mm`, no offset. */
export function clientLocalDateTime(now: Date = new Date()): string {
  return (
    `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}` +
    `T${pad2(now.getHours())}:${pad2(now.getMinutes())}`
  );
}

/** IANA zone name from the browser; "UTC" when the runtime cannot say. */
export function clientTimezone(): string {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zone && zone.trim() ? zone : "UTC";
  } catch {
    return "UTC";
  }
}

/** The calendar day of a client clock string, for the query key. */
export function localDateKey(localDateTime: string): string {
  return localDateTime.slice(0, 10);
}

export type HeadlineSplit = { before: string; accent: string; after: string };

/**
 * Split a headline around the first whole word "Puntt" so the hero can keep
 * the gradient accent on the brand name. Null when the word is absent.
 */
export function splitHeadlineOnPuntt(headline: string): HeadlineSplit | null {
  const match = /(^|[^A-Za-z0-9])(Puntt)(?![A-Za-z0-9])/.exec(headline);
  if (!match || match.index == null) return null;
  const start = match.index + match[1].length;
  return {
    before: headline.slice(0, start),
    accent: "Puntt",
    after: headline.slice(start + "Puntt".length),
  };
}
